// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".docContent {\n  padding-top: 65px;\n  padding-bottom: 20px;\n}\n.docContent title,\n.docContent meta {\n  display: none;\n}\n.docContent table {\n  font-size: 14px;\n  border-collapse: collapse;\n}\n.docContent table:not(:last-of-type) {\n  margin-bottom: 8px;\n}\n.docContent table tr,\n.docContent table td {\n  border: 1px solid ;\n}\n.docContent img {\n  max-width: 100%;\n  line-height: normal;\n  margin: 0;\n}\n", ""]);
// Exports
module.exports = exports;
